import { CSSObject } from 'styled-components';

export function lineClamp(
  display: '-webkit-inline-box' | '-webkit-box',
  webkitLineClamp: number,
  applyOverflowStyles: boolean = false
): CSSObject {
  return {
    display: display,
    overflow: 'hidden',
    WebkitLineClamp: webkitLineClamp,
    WebkitBoxOrient: 'vertical',
    ...(applyOverflowStyles && {
      overflowWrap: 'break-word',
      wordBreak: 'break-all',
      textOverflow: 'ellipsis',
    }),
  };
}
